module.exports = __webpack_public_path__ + "img/m5.52ccee156df03d352192a57cb5cf1d08.png";